const styles = theme => ({
  container: {
    padding: '16px 0',
  },
  balanceRow: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    marginBottom: 16,
    padding: '12px 16px',
    borderRadius: 8,
    background: theme.cardBackground || 'rgba(255,255,255,0.05)',
  },
  balanceLabel: {
    fontSize: 14,
    color: theme.textColorSecondary || '#999',
  },
  balanceValue: {
    fontSize: 20,
    fontWeight: 600,
    color: theme.textColor || '#fff',
  },
  inputGroup: {
    marginBottom: 16,
  },
  label: {
    fontSize: 14,
    color: theme.textColorSecondary || '#999',
    marginBottom: 8,
    display: 'block',
  },
  buttonRow: {
    display: 'flex',
    gap: 12,
    marginTop: 8,
  },
  statusText: {
    fontSize: 13,
    color: theme.textColorSecondary || '#999',
    marginTop: 8,
    textAlign: 'center' as const,
  },
});

export default styles;
